import StateCard from "../sharedUi/stateCard";
import { motion, AnimatePresence } from "framer-motion";
import { MdCategory } from "react-icons/md";
import { TbCategoryFilled } from "react-icons/tb";
import { RiPagesFill } from "react-icons/ri";
import InventoryIcon from '@mui/icons-material/Inventory';


export default function CategoryCardsUi ({value}) {

    return(<>
        <div>
            <AnimatePresence>  
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 py-4 mt-4 overflow-hidden"
                >
                {[
                    {
                    title: "No. Categories",
                    value: value.count_main_categories,
                    subtitle: "All Analytics",
                    icon: <MdCategory className="text-white" size={18} />,
                    iconBg: "bg-blue-700"
                    },
                    {
                    title: "No. Sub Categories",
                    value: value.count_sub_categories,
                    subtitle: "All Analytics",
                    icon: <TbCategoryFilled className="text-white" size={18} />,
                    iconBg: "bg-blue-700"
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            </AnimatePresence>
        </div>
    </>);
};